module.exports = __webpack_public_path__ + "static/img/bcg5.35133264.webp";